import { useId, useRef } from "react";
import useFocusTrap from "../utils/useFocusTrap";
import { trackEvent } from "../utils/analytics";
import "../styles/components/ConfirmationModal.css";

const HOTEL_ACCOMMODATIONS_URL =
  "https://www.marriott.com/event-reservations/reservation-link.mi?id=1767199105113&key=GRP&app=resvlink&_branch_match_id=1239728187785132198&_branch_referrer=H4sIAAAAAAAAA8soKSkottLXTywo0MtNLCrKzC8p0UvOz9UvSi3OyczLtgdK2ALZZSCOWmaKraG5mbmhpaWhgamhobFadmqlrXtQgFpdUWpaKlB3Xnp8UlF%2BeXFqka1zRlF%2BbioAakEdOWAAAAA%3D";

export default function ConfirmationModal({ open, onClose, summary }) {
  const dialogRef = useRef(null);
  const titleId = useId();

  useFocusTrap(dialogRef, open, onClose);

  if (!open) return null;

  return (
    <div className="modalOverlay" role="presentation">
      <div
        className="modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        ref={dialogRef}
        tabIndex={-1}
      >
        <button className="modal__close" type="button" onClick={onClose} aria-label="Close dialog">
          X
        </button>

        <h3 className="modal__title" id={titleId}>
          REGISTRATION
          <br />
          CONFIRMED!
        </h3>

        <p className="modal__body modal__body--tight">Thank you for registering.</p>
        <p className="modal__body">
          We're excited to have you join us at the 2026 Moët Hennessy
          <br />
          Distributor Conference - Future Forward.
        </p>

        <div className="modal__rule" aria-hidden="true" />

        <p className="modal__body modal__body--tight">A confirmation email has been sent to:</p>
        <p className="modal__email">{summary?.email ?? ""}</p>

        <div className="modal__summaryCard" aria-label="Registration summary">
          <div className="modal__summaryHeader">REGISTRATION SUMMARY</div>
          <div className="modal__summaryBody">
            <div className="modal__summaryLine">
              <span className="modal__summaryLabel">Name:</span>
              <span className="modal__summaryValue">{summary?.name ?? ""}</span>
            </div>
            <div className="modal__summaryLine">
              <span className="modal__summaryLabel">Email:</span>
              <span className="modal__summaryValue">{summary?.email ?? ""}</span>
            </div>
            <div className="modal__summaryLine">
              <span className="modal__summaryLabel">Company:</span>
              <span className="modal__summaryValue">{summary?.company ?? ""}</span>
            </div>
            <div className="modal__summaryLine">
              <span className="modal__summaryLabel">Dining Selection:</span>
              <span className="modal__summaryValue">{summary?.dinnerSelection ?? ""}</span>
            </div>
            <div className="modal__summaryLine">
              <span className="modal__summaryLabel">Dietary Restrictions:</span>
              <span className="modal__summaryValue">{summary?.dietaryRestrictions ?? ""}</span>
            </div>
          </div>
        </div>

        <a
          className="modal__cta"
          href={HOTEL_ACCOMMODATIONS_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() =>
            trackEvent("outbound_link_click", {
              link_text: "Register Hotel Accommodations",
              link_url: HOTEL_ACCOMMODATIONS_URL,
              outbound: true,
              section: "rsvp_confirmation_modal",
            })
          }
        >
          REGISTER HOTEL ACCOMMODATIONS
        </a>
      </div>
    </div>
  );
}
